export default "__VITE_ASSET__6968cae8__"